/*
  # Updated login slideshow to use static image
  
  1. Changes
    - Replaced slideshow with static snake mimicry image
    - Removed all slideshow logic and state management
    - Simplified component to display single image
*/

import React from 'react';

const LoginSlideshow = () => {
  return (
    <div className="relative h-full overflow-hidden rounded-xl">
      <img
        src="/assets/blog/snake-mimicry.webp"
        alt="Snake mimicry research"
        className="w-full h-full object-cover object-center"
      />
    </div>
  );
};

export default LoginSlideshow;